var Chart = require('chart.js');


var insertChart = function(canvasElement,data) {

    var ctx = canvasElement.getContext('2d');

    var myChart = new Chart(ctx, {
        type: 'pie',
        data: {
            labels: ["Viewed", "Unseen"],
            datasets: [{
                label: 'Stats',
                data: [ data.viewed, data.unseen],
                backgroundColor: [
                    'rgba(0, 168, 0, 0.7)',
                    'rgba(128, 28, 45, 0.7)',
                ],
            }]
        },
        options: { legend: { display : true }, responsive:false}
    });
}

module.exports = insertChart;


//////////////////
// WEBPACK FOOTER
// ./src/flashcard_review_chart.js
// module id = 312
// module chunks = 0